export default __webpack_public_path__ + "static/lock_gray-71ef5965450fcd71f621208a18bcf3d6.png";